
import { useTaskDrag } from '@/hooks/tasks/use-task-drag';
import { Task } from '@/types/tasks';

interface UseTaskCardDragProps {
  task: Task;
}

export const useTaskCardDrag = ({ task }: UseTaskCardDragProps) => {
  return useTaskDrag({
    id: task.id,
    task,
  });
};

export default useTaskCardDrag;
